import Contact from '@/classes/v2/Contact';

const setCurrentUserContacts = (state, rawContacts) => {
  state.currentUserContacts = rawContacts.map(rawContact => new Contact(rawContact));
};

const setEnterpriseContacts = (state, rawContacts) => {
  state.enterpriseContacts = rawContacts.map(rawContact => new Contact(rawContact));
};

const addUserContact = (state, rawContact) => {
  state.currentUserContacts.push(new Contact(rawContact));
};

const editUserContact = (state, rawContact) => {
  const updatedContact = new Contact(rawContact);
  const index = state.currentUserContacts.findIndex(
    contact => contact.id === updatedContact.id
  );
  if (index !== -1) {
    state.currentUserContacts.splice(index, 1, updatedContact);
  }
};

const updateContactAvatar = (state, contactAvatar) => {
  const { userId, image, mimeType } = contactAvatar;
  if (userId && image) {
    const index = state.enterpriseContacts.findIndex(
      c => c.userId === userId
    );
    if (index !== -1) {
      let updatedContact = new Contact(state.enterpriseContacts[index]);
      updatedContact.avatar = `data:${mimeType};base64,${image}`;
      state.enterpriseContacts.splice(index, 1, updatedContact);
    }
  }
};

const deleteUserContact = (state, contactId) => {
  const index = state.currentUserContacts.findIndex(contact => contact.contactId === contactId);
  if (index !== -1) {
    state.currentUserContacts.splice(index, 1);
  }
};

export default {
  addUserContact,
  editUserContact,
  deleteUserContact,
  setCurrentUserContacts,
  setEnterpriseContacts,
  updateContactAvatar
};
